import { render } from "./TabPane.vue?vue&type=template&id=7d98884a"
import script from "./TabPane.vue?vue&type=script&lang=ts"
export * from "./TabPane.vue?vue&type=script&lang=ts"
script.render = render

export default script